const checkboxHolderStyle = {border: '1px solid rgb(216,216,216)', padding: '5px', marginBottom: '20px', borderRadius: '5px'}

export {checkboxHolderStyle}
